import { useLayoutEffect } from 'react'

import { useUiTheme } from 'src/design-system/ui'

export const ProfessionalDocumentCanvas = () => {
  const { mode, variables } = useUiTheme()
  useLayoutEffect(() => {
    const elements = [document.documentElement, document.body]
    const previous = elements.map((element) => ({
      background: element.style.backgroundColor,
      color: element.style.color,
      colorScheme: element.style.colorScheme,
      fontFamily: element.style.fontFamily,
    }))
    elements.forEach((element) => {
      element.style.backgroundColor = variables['--ds-color-background']
      element.style.color = variables['--ds-color-foreground']
      element.style.colorScheme = mode
      element.style.fontFamily = variables['--ds-font-body']
    })
    document.documentElement.setAttribute('data-ui-canvas', 'professional')
    const margin = document.body.style.margin
    document.body.style.margin = '0'
    return () => {
      elements.forEach((element, index) =>
        Object.assign(element.style, previous[index])
      )
      document.documentElement.removeAttribute('data-ui-canvas')
      document.body.style.margin = margin
    }
  }, [mode, variables])
  return null
}
